// import React, { useState } from "react";
// import { Controller } from "react-hook-form";
// import Toaster from "../../common/Toaster";
// import { Button } from "reactstrap";

// const FileUploadSelfAssesment = ({
//   control,
//   name,
//   label,
//   onFileChange,
//   uploadedFile,
//   setIsoFile,
//   setUplaodedFile,
//   uploadClass,
//   deleteClass,
//   uploadWrapClass,
//   disabled,
//   downloadBtn
// }) => {
//   // const handleDelete = () => {
//   //   void Toaster.error("File Deleted");
//   //   setIsoFile(null);
//   //   if (setUplaodedFile) {
//   //     setUplaodedFile(null);
//   //   }
//   // };
//   const handleDownload = (e, file) => {
//     e.preventDefault(); // Prevent default behavior of the button
//     if (file) {
//       const link = document.createElement("a");
//       link.href = file;
//       link.target = "_blank";
//       link.download = "downloadedFile";

//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }
//   };

//   return (
//     <Controller
//       name={name}
//       control={control}
//       defaultValue={null}
//       render={({ field }) => (
//         <div className={`hl-upload-delete-wrap ${uploadWrapClass || ""}`}>
//           <div className="hl-upload-btn-small">
//             {!disabled && (
//               <Button
//                 className={`hl-upload-btn right ${uploadClass || ""}`}
//                 variant="upload"
//                 title="Upload"
//                 onClick={() => {
//                   document.getElementById(name).click();
//                 }}
//               >
//                 <div class="upload mr-0"></div>
//               </Button>
//             )}
//             <input
//               type="file"
//               id={name}
//               style={{ display: "none" }}
//               onChange={(e) => {
//                 onFileChange(e.target.files[0]);
//                 field.onChange(e.target.files[0]);
//               }}
//             />
//           </div>

//           <div className="hl-download-btn hl-file-upload-title">
//             <div className="hl-file-title">
//               <span title={field.value ? field.value?.name : ""}>
//                 {field.value ? field.value?.name : ""}
//               </span>
//             </div>

//             {uploadedFile && disabled && (
//               <button
//                 className={`btn btn-secondary hl-download-btn hl-upload-btn ml-4 ${downloadBtn || ""}`}
//                 onClick={(e) => handleDownload(e, uploadedFile)}
//                 title="Download"
//               >
//                 <div class="download mr-0"></div>
//               </button>
//             )}
//           </div>
//         </div>
//       )}
//     />
//   );
// };

// export default FileUploadSelfAssesment;
import { Controller } from "react-hook-form";
import { Button } from "reactstrap";
import React from "react";

const FileUploadSelfAssesment = ({
  control,
  name,
  uploadedFile,
  allowedFileTypes,
  uploadClass,
  uploadWrapClass,
  disabled,
  // handleRegisterUpload, // Receive handleRegisterUpload function as a prop
}) => {
  const handleFileChange = (e) => {
    const file = e?.target?.files[0];
    if (file) {
      // handleRegisterUpload(file); // Call handleRegisterUpload function
    }
  };

  const handleDownload = (e, file) => {
    e.preventDefault();
    if (file) {
      const link = document.createElement("a");
      link.href = file;
      link.target = "_blank";
      link.download = "downloadedFile";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  const isAcceptedFormat = (file) => {
    return file && allowedFileTypes?.includes(file?.type);
  };
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field }) => (
        <div className={`hl-upload-delete-wrap ${uploadWrapClass || ""}`}>
          <div className="hl-upload-btn-small">
            {!disabled && (
              <Button
                className={`hl-upload-btn right ${uploadClass || ""}`}
                variant="upload"
                title="Upload"
                onClick={() => {
                  document.getElementById(name).click();
                }}
              >
                <div class="upload mr-0"></div>
              </Button>
            )}
            <input
              type="file"
              id={name}
              style={{ display: "none" }}
              onChange={(e) => {
                handleFileChange(e);
                field.onChange(e.target.files[0]);
              }}
            />
          </div>
          <div className="hl-download-btn hl-file-upload-title">
            <div className="hl-file-title">
              <span
                title={isAcceptedFormat(field.value) ? field.value?.name : ""}
              >
                {isAcceptedFormat(field.value) ? field.value?.name : ""}
              </span>
            </div>
            {uploadedFile && disabled && (
              <button
                className="btn btn-secondary hl-download-btn hl-upload-btn ml-4"
                onClick={(e) => handleDownload(e, uploadedFile)}
                title="Download"
              >
                <div class="download mr-0"></div>
                {/* Download */}
              </button>
            )}
          </div>
        </div>
      )}
    />
  );
};

export default FileUploadSelfAssesment;
